import { useTranslation } from 'react-i18next';
import { WarningIconWithTooltip } from '@commonClient2/components';

/**
 * @param {Setup.ISetupBrief} rowData 
 * @returns {JSX.Element|null}
 */
const renderWarningColumn = (rowData) => {
    const { warnings } = rowData;

    if (!warnings || warnings.length === 0) {
        return null;
    }
    
    return <WarningColumnComponent warnings={warnings} />;
};

const WarningColumnComponent = ({ warnings }) => {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.warnings' });
    
    const tooltipWarnings = warnings.map((warningCode) => t(warningCode));
    
    return (
        <div className="warning-icon-column-item">
            <WarningIconWithTooltip
                tooltipWarnings={tooltipWarnings}
                fontSize="medium"
            />
        </div>
    );
};

const columns = [
    {
        key: 'name',
        tKey: 'columns.bidSetup.name',
        sortable: true,
        flexGrow: 3,
    },
    {
        key: 'warning',
        tKey: 'columns.bidSetup.warning',
        sortable: false,
        flexGrow: 1,
    },
    {
        key: 'description',
        tKey: 'columns.bidSetup.description',
        sortable: true,
        flexGrow: 4,
    },
    {
        key: 'bidProcessTypeName',
        tKey: 'columns.bidSetup.bidType',
        sortable: true,
        flexGrow: 1,
    },
    {
        key: 'creationHyperfindName',
        tKey: 'columns.bidSetup.whoCanCreate',
        sortable: true,
        flexGrow: 2,
        isTooltip: true,
    },
    {
        key: 'managementHyperfindName',
        tKey: 'columns.bidSetup.whoCanManage',
        sortable: true,
        flexGrow: 2,
        isTooltip: true,
    },
    {
        key: 'viewHyperfindName',
        tKey: 'columns.bidSetup.whoCanView',
        sortable: true,
        flexGrow: 2,
        isTooltip: true,
    },
    {
        key: 'autoApprovalName',
        tKey: 'columns.bidSetup.approvalProcess',
        sortable: true,
        flexGrow: 2,
    },
    {
        key: 'scheduleSourceName',
        tKey: 'columns.bidSetup.scheduleSource',
        sortable: true,
        flexGrow: 2,
    },
];

export { renderWarningColumn };
export default columns;
